module.exports = __webpack_public_path__ + "static/media/fish.29d5a58f.svg";